@if (details(); as learningPlanInstanceDetails) {
  <div class="mx-8 mb-24 mt-20" *transloco="let t" animate.enter="ease-in-fast">
    <div class="mb-8 flex w-full items-center justify-between gap-2">
      <h1 class="text-3xl font-semibold">
        {{
          'portal.trainings.trainingNameKeys.' +
            learningPlanInstanceDetails.name
            | translocoWithFallback
              : undefined
              : learningPlanInstanceDetails.name
        }}
      </h1>
      <div class="flex gap-2">
        <button
          class="flex items-center justify-center rounded-lg border border-grey-lightGrey p-2 text-grey transition-colors hover:bg-grey-lightGrey"
          [matMenuTriggerFor]="settingsMenu"
          title="Settings"
        >
          <mat-icon class="material-icons-outlined text-grey">
            settings
          </mat-icon>
        </button>
      </div>

      <mat-menu
        #settingsMenu="matMenu"
        [overlapTrigger]="false"
        xPosition="before"
        yPosition="below"
      >
        @if (canEdit()) {
          <button mat-menu-item (click)="onEditButtonClick()">
            <mat-icon class="material-icons-outlined">edit</mat-icon>
            <span>{{
              'portal.trainings.detailPage.editButton' | transloco
            }}</span>
          </button>
        }
        <button mat-menu-item (click)="onDeleteButtonClick()">
          <mat-icon class="material-icons-outlined text-cancel">
            delete_forever
          </mat-icon>
          <span>{{
            'portal.trainings.detailPage.deleteButton' | transloco
          }}</span>
        </button>
      </mat-menu>
    </div>

    <!-- Overview Section -->
    <div class="mt-10">
      <app-learning-plan-statistics
        [startAt]="learningPlanInstanceDetails.startAt"
        [phaseDuration]="phaseDuration()"
        [numberOfEnrolledStudents]="
          learningPlanInstanceDetails.numberOfEnrolledStudents
        "
        [numberOfCompletedStudents]="
          learningPlanInstanceDetails.numberOfCompletedStudents
        "
        [numberOfEnrolledStudentsLearningPlanStarted]="
          learningPlanInstanceDetails.numberOfEnrolledStudentsLearningPlanStarted
        "
        [status]="learningPlanInstanceDetails.status"
        [phaseStart]="selectedPeriodPickerControlOption()?.startDate"
        [phaseEnd]="selectedPeriodPickerControlOption()?.endDate"
        [isLooping]="isLooping()"
        [deadline]="deadline()"
        [isDeadlinePassed]="isDeadlinePassed()"
      />
    </div>

    <div class="mt-10 w-full">
      <app-learning-plan-structure
        [phases]="learningPlanInstanceDetails.orderedPhases || []"
        [looping]="isLooping()"
        [hasDeadline]="hasDeadline()"
      ></app-learning-plan-structure>
    </div>

    <!-- Participants Section -->
    <div class="mt-10">
      <app-learning-plan-enrolled-student-table
        [students]="tableStudents()"
        [allowEnrollment]="canEnroll()"
        [periodPickerControl]="periodPickerControl"
        [periodPickerOptions]="periodPickerOptions()"
        [hasDeadline]="hasDeadline()"
        [isEnrollmentBlockedByDeadline]="isDeadlinePassed()"
        (enrollButtonClicked)="onEnrollButtonClick()"
      />
    </div>

    <!--router outlet for route aware dialog-->
    <router-outlet></router-outlet>
  </div>
}
